<script setup lang="ts">
/**
 * 领域徽章。
 *
 * 安全等级高的领域（critical/high）用琥珀色而不是主色：这两类问题
 * （如自伤风险）在同一屏里必须与"普通咨询"在视觉上分开，
 * 否则用户会把一个需要立即处理的回答当成一次普通问答。
 */

import { DOMAIN_META, type Domain } from '@spirit/contracts';

import { cn } from '../../lib/cn';

const props = defineProps<{ domain: Domain; className?: string }>();

const meta = DOMAIN_META[props.domain];
</script>

<template>
  <span
    :class="
      cn(
        'inline-flex items-center rounded px-1.5 py-0.5 text-[11px] font-medium',
        meta.safetyLevel === 'critical' || meta.safetyLevel === 'high'
          ? 'bg-amber-100 text-amber-800'
          : 'bg-brand-50 text-brand-700',
        props.className,
      )
    "
    :title="meta.safetyNote"
  >
    {{ meta.label }}
  </span>
</template>
